import { useState } from "react";
import { Modal } from "pepsico-ds";
import PropTypes from "prop-types";
import "../../campaign/ActivitySetup/ruleSelectorModal/rule-selector-modal.scss";

const LimitTypeSelectorModal = ({
  show,
  onClose,
  limitTypes,
  onSelectLimit,
  title = "Add Limit",
}) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleAddLimit = () => {
    if (selectedIndex !== null) {
      onSelectLimit(limitTypes[selectedIndex]);
    }
    handleClose();
  };

  const handleClose = () => {
    setSelectedIndex(null);
    onClose();
  };

  return (
    <Modal
      showModal={show}
      onCloseModal={handleClose}
      title={title}
      primaryButtonProps={{
        text: "Next",
        onClick: handleAddLimit,
        disabled: selectedIndex === null,
        size: "medium",
        variant: "primary",
      }}
      secondaryButtonProps={{
        text: "Cancel",
        onClick: handleClose,
        size: "medium",
        variant: "tertiary",
      }}
      showTertiaryButton={false}
      className="rule-selector-modal"
      showLink={false}
    >
      <div className="rules-grid">
        {limitTypes.map((limitType, index) => (
          <button
            key={limitType.key}
            className={`rule-item ${selectedIndex === index ? "selected" : ""}`}
            onClick={() => setSelectedIndex(index)}
          >
            <span className="font-heading-h6-bold">{limitType.label}</span>
            <span className="font-small-regular">
              {limitType.description || "No description available"}
            </span>
          </button>
        ))}
      </div>
    </Modal>
  );
};

LimitTypeSelectorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  limitTypes: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
  onSelectLimit: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default LimitTypeSelectorModal;
